var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15526_168500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.588 3.4L1.688 8.3C1.488 8.5 1.25467 8.59583 0.988 8.5875C0.721333 8.57917 0.488 8.475 0.288 8.275C0.104667 8.075 0.00883333 7.84167 0.0005 7.575C-0.00783333 7.30833 0.088 7.075 0.288 6.875L6.888 0.275C6.988 0.175 7.09633 0.104167 7.213 0.0625C7.32967 0.0208333 7.45467 0 7.588 0C7.72133 0 7.84633 0.0208333 7.963 0.0625C8.07967 0.104167 8.188 0.175 8.288 0.275L14.888 6.875C15.0713 7.05833 15.163 7.2875 15.163 7.5625C15.163 7.8375 15.0713 8.075 14.888 8.275C14.688 8.475 14.4505 8.575 14.1755 8.575C13.9005 8.575 13.663 8.475 13.463 8.275L8.588 3.4V14.575C8.588 14.8583 8.49217 15.0958 8.3005 15.2875C8.10883 15.4792 7.87133 15.575 7.588 15.575C7.30467 15.575 7.06717 15.4792 6.8755 15.2875C6.68383 15.0958 6.588 14.8583 6.588 14.575V3.4Z",
    fill: "#204A22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15526_168500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDark);
export default __webpack_public_path__ + "static/media/arrow-up-dark.a1b04423b01f15b6620c2168f1e7a061.svg";
export { ForwardRef as ReactComponent };